// src/firebase.js
import { initializeApp } from 'firebase/app';

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error('Missing required Firebase configuration in environment variables.');
}

const app = initializeApp(firebaseConfig);

// Initialize auth and related functions synchronously
import { getAuth, GoogleAuthProvider, sendEmailVerification } from 'firebase/auth';

const authInstance = getAuth(app);
const googleProviderInstance = new GoogleAuthProvider();
googleProviderInstance.setCustomParameters({ prompt: 'select_account' });

// Export as direct values instead of functions
export { authInstance as auth, googleProviderInstance as googleProvider, sendEmailVerification };

export { app };

//console.log('Firestore instance:', getFirestore(app));
import { getFirestore } from 'firebase/firestore';
// export const db = getFirestore(app);
const db = getFirestore(app);
export { db }
